// The genre vocabulary the Artist Profile picker offers (≤ 3, `MAX_GENRES`). `band_profiles.genres` is a free
// `text[]` with no server enum, so this list is the picker's and nothing else's: a saved value missing from it still
// renders as a removable chip and is never dropped. Alphabetical, as the source list was supplied (2026-10-14).
export const GENRES: readonly string[] = [
  "2-Step Garage",
  "Acid House",
  "Acid Jazz",
  "Acid Techno",
  "Afrobeats",
  "Alt-Country",
  "Alternative Hip Hop",
  "Alternative Metal",
  "Alternative Rock",
  "Amapiano",
  "Ambient",
  "Americana",
  "Anti-Folk",
  "Art Pop",
  "Atmospheric Black Metal",
  "Avant-Garde Jazz",
  "Bachata",
  "Baile Funk",
  "Baroque Pop",
  "Bebop",
  "Big Band",
  "Bitpop",
  "Black Metal",
  "Bluegrass",
  "Blues Rock",
  "Boom Bap",
  "Bossa Nova",
  "Breakcore",
  "Bro-Country",
  "Brostep",
  "Chamber Pop",
  "Chicago Blues",
  "Chicago House",
  "Chillwave",
  "Chiptune",
  "Chiraq Drill",
  "City Pop",
  "Classic Rock",
  "Cloud Rap",
  "Coldwave",
  "Conscious Hip Hop",
  "Contemporary Folk",
  "Contemporary R&B",
  "Cool Jazz",
  "Country Pop",
  "Crossover Thrash",
  "Crunk",
  "Crust Punk",
  "Cumbia",
  "D-Beat",
  "Dance-Pop",
  "Dancehall",
  "Dark Ambient",
  "Darksynth",
  "Darkwave",
  "Death Metal",
  "Deathcore",
  "Deep House",
  "Delta Blues",
  "Disco",
  "Djent",
  "Doom Metal",
  "Dream Pop",
  "Drift Phonk",
  "Drill",
  "Drone Metal",
  "Drone Music",
  "Drum and Bass",
  "Dub",
  "Dub Techno",
  "Dubstep",
  "EBM",
  "Electric Blues",
  "Electro House",
  "Electronicore",
  "Emo Rap",
  "Emocore",
  "Enka",
  "Eurodance",
  "Fado",
  "Flamenco",
  "Folk Rock",
  "Freak Folk",
  "Free Jazz",
  "Funk",
  "G-Funk",
  "Garage Rock",
  "Ghetto House",
  "Glam Metal",
  "Glitch Hop",
  "Goregrind",
  "Gothic Metal",
  "Gothic Rock",
  "Grime",
  "Grindcore",
  "Groove Metal",
  "Grunge",
  "Gypsy Jazz",
  "Hard Bop",
  "Hard Rock",
  "Hardcore",
  "Hardcore Hip Hop",
  "Hardcore Punk",
  "Hardstyle",
  "Highlife",
  "House",
  "Hyperpop",
  "Hyphy",
  "IDM",
  "Indie Folk",
  "Indie Pop",
  "Indie Rock",
  "Industrial Metal",
  "J-Pop",
  "Jazz Fusion",
  "Jazz Rap",
  "Jump Up",
  "K-Pop",
  "Kuduro",
  "Liquid Funk",
  "Mariachi",
  "Math Rock",
  "Mathcore",
  "Melodic Death Metal",
  "Melodic Metalcore",
  "Merengue",
  "Metalcore",
  "Metallic Hardcore",
  "Midwest Emo",
  "Minimal Techno",
  "Modal Jazz",
  "Modern Classical",
  "Motown",
  "Mumble Rap",
  "Neo-Soul",
  "Neoclassical",
  "Neurofunk",
  "New Jack Swing",
  "New Orleans Jazz",
  "New Wave",
  "Noise Music",
  "Noise Rock",
  "Northern Soul",
  "Nu Metal",
  "Nu Metalcore",
  "Outlaw Country",
  "P-Funk",
  "Phonk",
  "Plugg",
  "Pluggnb",
  "Pop Punk",
  "Post-Grunge",
  "Post-Hardcore",
  "Post-Metal",
  "Post-Punk",
  "Post-Rock",
  "Power Metal",
  "Progressive House",
  "Progressive Metal",
  "Progressive Metalcore",
  "Psychedelic Rock",
  "Psytrance",
  "Quiet Storm",
  "Ranchera",
  "Reggae",
  "Reggae Rock",
  "Reggaeton",
  "Riddim",
  "Rocksteady",
  "Salsa",
  "Samba",
  "Screamo",
  "Shoegaze",
  "Ska",
  "Ska Punk",
  "Skate Punk",
  "Slam Death Metal",
  "Sludge Metal",
  "Smooth Jazz",
  "Soukous",
  "Soul",
  "Southern Rock",
  "Speed Metal",
  "Stoner Metal",
  "Swing",
  "Symphonic Metal",
  "Synthpop",
  "Synthwave",
  "Tango",
  "Tech House",
  "Technical Death Metal",
  "Techno",
  "Texas Blues",
  "Thall",
  "Thrash Metal",
  "Traditional Country",
  "Traditional Folk",
  "Traditional Pop",
  "Trance",
  "Trap (EDM)",
  "Trap (Hip Hop)",
  "Trip Hop",
  "Trot",
  "UK Drill",
  "UK Garage",
  "Uplifting Trance",
  "Vaporwave",
  "Vocal Trance",
];
